import { LegalPage, defaultPrivacyContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

export function Privacy() {
  const content = useCmsContent("privacy", defaultPrivacyContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <LegalPage content={content} />;
}
